import React from "react"
import Debug from "@/components/Debug"

export default function DebugView() {
  return <Debug />
}
